import cn from 'clsx'
import s from './ComparisonSection.module.scss'
import { FC, useRef } from 'react'
import {
  Text,
  CustomImage,
  Container,
  Button,
  VideoPlayer,
} from '@components/ui'

import { Product } from '@commerce/types/product'
// import ProductCard from './ProductCard/ProductCard'
import { LoreThreePage } from '@generated/model/loreThreePage'
import { ControlBar, Player, PlayerReference } from 'video-react'
import ComparisonBlock from './ComparisonBlock'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'

type ComparisonSectionProps = {
  page: LoreThreePage
}

const ComparisonSection: FC<ComparisonSectionProps> = ({ page }) => {
  const playerRef = useRef<PlayerReference>(null)

  if (page.comparison_section == null) return null
  const source =
    page.comparison_section.video || page.comparison_section.video_url
  return (
    <>
      <Container>
        <section className={s.root}>
          <div className={cn(s.grid)}>
            {source && (
              <VideoPlayer
                data={page.comparison_section}
                controls={page.comparison_section.controls || false}
                className={s.videoContainer}
                preload="metadata"
              />
            )}

            <div className={s.title}>
              <Text variant="pageHeading">{page.comparison_section.title}</Text>
            </div>
            {/* <div className={s.blocks}>
              {page.comparison_blocks?.map((block, index) => (
                <ComparisonBlock
                  key={`comparison-block-${index}`}
                  block={block}
                />
              ))}
            </div> */}
          </div>
        </section>
      </Container>
    </>
  )
}

export default ComparisonSection
